<template>
  <div>
    <div class="row">
      <div class="col-sm-2">
        <div>
          <img :src="'/images/logolayout.png'" alt="" />
        </div>
      </div>
      <div class="col-sm-10">
        <div>
          <h2 style="font-weight: 600; margin-bottom: 0.5rem !important">
            Company Organogram
          </h2>
          <small style="font-size: 80% !important"
            >Company Organogram for your profile page</small>
        </div>
      </div>
    </div>
    <form ref="form" data-url="/admin/company/profile/edit-organogram" class="mt-4" enctype="multipart/form-data">
      <div class="form-group row mb-0">
        <!-- <label class="col-sm-2 mb-sm-0">
          {{ $t("upload_with_preview") }}
        </label> -->
        <div class="col-sm-8">
          <app-input
            type="custom-file-upload"
            :label="$t('upload_your_file')"
            v-model="inputs.company_organogram"
            :required="true"
          />
          <small class="text-muted font-italic">
            {{ $t("recommended_custom_file_validation") }}
          </small>
        </div>
      </div>
      <div class="mt-2" v-if="userRole.company_id == inputs.id">
        <!-- <button class="btn btn-primary" @click.prevent="submit">Save</button> -->
        <app-load-more
                  :preloader="preloader"
                  :label="$t('save')"
                  type="submit"
                  class-name="btn btn-primary text-center"
                  @submit="submit"
                />
      </div>
    </form>
  </div>
</template>
<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
// import { COMPANY_PROFILE_DETAIL } from "../../../../Config/ApiUrl";
export default {
  mixins: [FormMixin],
  data() {
    return {
      inputs: {
        company_organogram: this.$store.state.userCompanyProfile.dataProfile.company.organogram,
        id: this.$store.state.userCompanyProfile.dataProfile.company.id,
      },
      data:{},
    };
  },
  computed: {
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
  },
  // props:['props'],
  methods: {
      beforeSubmit(){
        this.preloader = true;
      },
      submit()
      {
        let formData = new FormData;
          for (const [key, value] of Object.entries(this.inputs)) {
              formData.append(key, value);
          }
          
          this.save(formData);    
      },


      afterSuccess(res) {
      this.$toastr.s(res.data.message);
      },
      afterFinalResponse() {
        this.preloader = false;
      },
      afterError(res) {
        this.$toastr.e(res.data.message);
      },
    },
    // mounted(){
    //   
    //   
    // }
};
</script>
